import { inject, Injectable, NgZone } from '@angular/core';

export enum ApplicationContainer {
  CONTAINER_PORTAL = 'div[name="portalContentContainer"]',
  CHAT_CONVERSATION = 'section[name="chatConversationContainer"',
}

@Injectable({
  providedIn: 'root',
})
export class UtilityService {
  #zone = inject(NgZone);

  scrollToBottom(selector?: string) {
    this.#zone.runOutsideAngular(() => {
      const el = document.querySelector(selector ?? 'body') as HTMLElement;
      if (!el) {
        return;
      }
      const scrollable = el.scrollHeight > el.clientHeight;
      if (scrollable) {
        el.scrollTo({
          top: el.scrollHeight - el.clientHeight,
          behavior: 'smooth',
          left: 0,
        });
      }
    });
  }
}
